import { Platform, StyleSheet, View } from "react-native";
import Colors from "../../constants/Colors";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import OfflineBanner from "../OfflineBanner";
import { useContext } from "react";
import GlobalContext from "../../context/Global";

type Props = {
  leftComponent?: JSX.Element;
  centerComponent?: JSX.Element;
  rightComponent?: JSX.Element;
  contentAware?: boolean;
  offlineBannerMessage?: string;
  horizontalPadding?: number;
  pagePingTime?: number;
  bottomBorder?: boolean;
};

export default function PageHeader(props: Props) {
  const { isTablet } = useContext(GlobalContext);
  const insets = useSafeAreaInsets();
  const {
    leftComponent,
    centerComponent,
    rightComponent,
    contentAware = true,
    offlineBannerMessage,
    horizontalPadding = Platform.OS === "web" ? 64 : 20,
    bottomBorder = false,
  } = props;

  return (
    <View>
      <View
        style={[
          styles.container,
          {
            paddingTop: contentAware ? insets.top + 16 : 20,
            paddingHorizontal: horizontalPadding,
            borderBottomColor: Colors.tinted_grey_300,
            borderBottomWidth: bottomBorder ? 0.5 : 0,
          },
        ]}
      >
        <View style={[styles.componentSquare, styles.leftComponentSquare]}>
          {leftComponent}
        </View>
        <View
          pointerEvents="box-none"
          style={[
            styles.centerComponentWrapper,
            {
              paddingTop: Platform.OS === "web" ? 0 : isTablet ? 8 : 14,
            },
          ]}
        >
          <View style={styles.centerComponent}>{centerComponent}</View>
        </View>
        <View style={[styles.componentSquare, styles.rightComponentSquare]}>
          {rightComponent}
        </View>
      </View>
      {offlineBannerMessage && <OfflineBanner message={offlineBannerMessage} />}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: 28,
    flexDirection: "row",
    backgroundColor: Colors.base_colors_white,
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 1,
  },
  componentSquare: {
    justifyContent: "center",
  },
  leftComponentSquare: {
    alignItems: "flex-start",
    zIndex: 9,
  },
  rightComponentSquare: {
    alignItems: "flex-end",
  },
  centerComponentWrapper: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "box-none",
  },
  centerComponent: {
    alignSelf: "center",
  },
});
